// src/utils/plan.ts

export function resolveCurrentShopUrl(user: any, explicitShopUrl?: string): string {
    const direct = String(explicitShopUrl ?? "").trim();
    if (direct) return direct;

    const shopUrl = String(user?.shopUrl ?? "").trim();
    if (shopUrl) return shopUrl;

    const shopUrlFromAuth = String(user?.shopUrlFromAuth ?? "").trim();
    if (shopUrlFromAuth) return shopUrlFromAuth;

    const companies = Array.isArray(user?.adminCompanies) ? user.adminCompanies : [];
    if (companies.length === 1) {
        return String(companies[0]?.shopUrl ?? "").trim();
    }

    return "";
}

export function resolveCurrentPlan(user: any, explicitShopUrl?: string): string {
    const companies = Array.isArray(user?.adminCompanies) ? user.adminCompanies : [];
    const currentShopUrl = resolveCurrentShopUrl(user, explicitShopUrl);

    if (currentShopUrl) {
        const hit = companies.find(
            (c: any) => String(c?.shopUrl ?? "").trim() === currentShopUrl
        );
        const hitPlan = String(hit?.plan ?? "").trim();
        if (hitPlan) return hitPlan;
    }

    const rootPlan = String(user?.plan ?? "").trim();
    if (rootPlan) return rootPlan;

    if (companies.length === 1) {
        const singlePlan = String(companies[0]?.plan ?? "").trim();
        if (singlePlan) return singlePlan;
    }

    // ✅ fallback: Header と揃える
    if (typeof window !== "undefined") {
        const storagePlan = String(localStorage.getItem("plan") || "").trim();
        if (storagePlan) return storagePlan;
    }

    return "";
}

export function isFreePlanUser(user: any, explicitShopUrl?: string): boolean {
    return resolveCurrentPlan(user, explicitShopUrl) === "フリープラン";
}

export function isLightPlanUser(user: any, explicitShopUrl?: string): boolean {
    return resolveCurrentPlan(user, explicitShopUrl) === "ライトプラン";
}

export function isStandardEquivalentPlan(plan: unknown): boolean {
    const normalized = String(plan ?? "").trim().toLowerCase();
    return (
        normalized.includes("スタンダード") ||
        normalized.includes("standard") ||
        normalized === "プラス" ||
        normalized === "プラスプラン" ||
        normalized === "plus" ||
        normalized === "plus plan"
    );
}